import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types';

export default function NewsCard({ article }: { article: NewsArticle }) {
  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex gap-4 bg-background-100 border border-background-300/50 rounded-lg p-3 hover:border-primary-500/60 transition-colors"
    >
      <div className="w-28 h-20 md:w-36 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} - 电影资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-1.5">
          <span className="px-2 py-0.5 rounded bg-secondary-800 text-secondary-200">{article.category}</span>
          <span>{article.date}</span>
        </div>
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-400 transition-colors">
          {article.title}
        </h3>
        <p className="hidden sm:block text-xs text-foreground-600 mt-1.5 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
      </div>
    </Link>
  );
}